/** How the piece looks as a Google result, and the counters under its search fields. */

export const TITLE_LIMIT = 60
export const DESCRIPTION_LIMIT = 155

/** `s` cut to at most `max` characters, the "…" included, never ending on a space. */
export function truncate(s: string, max: number): string {
  const t = s.trim()
  if (t.length <= max) return t
  return `${t.slice(0, max - 1).trimEnd()}…`
}

export type SearchPreview = { title: string; description: string }

export function searchPreview(d: { seo_title: string | null; title: string | null; meta_description: string | null }): SearchPreview {
  const title = d.seo_title?.trim() || d.title?.trim() || 'Untitled piece'
  return { title: truncate(title, TITLE_LIMIT), description: truncate(d.meta_description ?? '', DESCRIPTION_LIMIT) }
}

/** "flightjournal.com › flight-line › slug" from a live URL; the section's name before there is one. */
export function searchCrumb(publicUrl: string | null | undefined, sectionLabel: string): string {
  if (!publicUrl) return sectionLabel
  try {
    const u = new URL(publicUrl)
    const host = u.host.replace(/^www\./, '')
    return [host, ...u.pathname.split('/').filter(Boolean)].join(' › ')
  } catch {
    return sectionLabel
  }
}

export function counterText(length: number, limit: number): { text: string; over: boolean } {
  const over = length > limit
  return { text: `${length} of ${limit} characters${over ? ': Google will cut the end' : ''}`, over }
}
